'use client';

interface MainHeaderSkeletonProps {
	variant: 'navigation' | 'main';
}

export const MainHeaderSkeleton = ({ variant }: MainHeaderSkeletonProps) => {
	return (
		<div className="m-auto flex h-9 w-full items-center justify-between">
			{variant === 'navigation' ? (
				<div className="mx-0 flex h-6 items-center gap-2 px-0">
					<div className="size-5 animate-pulse rounded bg-gray-200" />
					<div className="h-6 w-24 animate-pulse rounded bg-gray-200" />
				</div>
			) : (
				<>
					<div className="mx-0 flex h-6 items-center gap-2 px-0">
						<div className="size-5 animate-pulse rounded bg-gray-200" />
						<div className="h-6 w-32 animate-pulse rounded bg-gray-200" />
					</div>

					<div className="hidden items-center gap-6 sm:flex">
						<div className="flex items-center gap-2">
							<div className="size-5 animate-pulse rounded bg-gray-200" />
							<div className="h-6 w-20 animate-pulse rounded bg-gray-200" />
						</div>

						<div className="flex items-center gap-2">
							<div className="size-5 animate-pulse rounded bg-gray-200" />
							<div className="h-6 w-16 animate-pulse rounded bg-gray-200" />
							<div className="size-4 animate-pulse rounded bg-gray-200" />
						</div>

						<div className="flex items-center gap-2">
							<div className="size-5 animate-pulse rounded bg-gray-200" />
							<div className="h-6 w-12 animate-pulse rounded bg-gray-200" />
							<div className="size-4 animate-pulse rounded bg-gray-200" />
						</div>

						<div className="ml-3">
							<div className="size-9 animate-pulse rounded-full bg-gray-200" />
						</div>
					</div>
				</>
			)}
		</div>
	);
};
